/**
 * Hourglass internal-staff access control.
 *
 * Gates the `/internal` workspace — a separate dashboard used by Hourglass
 * employees to inspect time entries on behalf of attorneys at the firm whose
 * tenant subdomain they're currently on.
 *
 * v1: any `@hourglass.law` email gets in. If we later need finer-grained
 * permissions (e.g., contractors with `@hourglass.law` who shouldn't see
 * editing), grow this into a `getHourglassPermissions(email)` shaped like
 * `getAdminPermissions` without breaking callers.
 */

// Accounts that must NOT see the Internal workspace despite carrying an
// @hourglass.law address. Checked before the dev override so the exclusion
// also holds when running the local dev server (e.g., demos).
const INTERNAL_EXCLUDED = new Set(["dayn@hourglass.law"]);

export const isHourglassInternal = (_userEmail?: string): boolean => {
	if (!_userEmail) return false;

	const email = _userEmail.toLowerCase();
	if (INTERNAL_EXCLUDED.has(email)) return false;

	// Local visual-testing override: show the Internal workspace for any
	// signed-in user in dev without requiring an @hourglass.law address.
	if (import.meta.env.DEV) return true;

	return email.endsWith("@hourglass.law");
};
